import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';
import { morph, MORPH_OPTIONS } from '@theme/morph';

/**
 * PokerVault PDP price + entries live-updater.
 *
 * Horizon's `<product-price>` only swaps `[ref="priceContainer"]`, but
 * the PV block also renders an entries pill whose count is
 * derived from the variant price — so we morph the WHOLE block when
 * the user picks a different size. Mirrors the listener pattern in
 * `assets/product-price.js`.
 *
 * @extends {Component}
 */
class PvPriceAndEntries extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.#update);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.#update);
  }

  #update = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newBlock = event.detail.data.html.querySelector(
      `pv-price-and-entries[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newBlock) return;

    morph(this, newBlock, MORPH_OPTIONS);
  };
}

if (!customElements.get('pv-price-and-entries')) {
  customElements.define('pv-price-and-entries', PvPriceAndEntries);
}
